import React from 'react'
import './dashboardTablero.css'
import './DashboardMujeres.css'
import logoSev from '../../images/logoSev.png';
import logoVer from '../../images/veracruz.png';
import imgMujer from '../../images/MujerImagen.png'
import MapaVeracruzM from './componentesNew/MapaVeracruzM';
import TrabajadorasChart from './componentesNew/TrabajadorasChart';
function DashboardMujeres() {
  return (
    <>

      <div className="tituloTablero shadow-lg">
        Tablero de Informacion de Nómina de la Secretaria de Educación Veracruz Enero-Diciembre 2024.
      </div>

      <div className="d-flex justify-content-center">
        <div class="row bannerTablero">
          <div class="col logoSev d-flex  align-items-center">
            <img src={logoSev} alt="" height={80} />
            <img src={logoVer} alt="" height={50} />
          </div>

        </div>

      </div>
      <div className='d-flex justify-content-center mb-2'>
        <h2 className='tituloTabla'>LAS MUJERES EN LA EDUCACION DE VERACRUZ</h2>
      </div>
      <div class="containerMujeres">
        <div class="itemMujeres ">
          <h3 className='tituloTabla pb-2'>TRABAJADORAS-PLAZA</h3>
          <div>
            <h1 className='tituloConcepto'>6 mil </h1>
            <h5 className='tituloTabla mb-1'>PLAZAS ADMINISTRATIVAS</h5>
          </div>
          <div>
            <h1 className='tituloConcepto'>38 mil </h1>
            <h5 className='tituloTabla mb-1'>PLAZAS DOCENTES</h5>
          </div>
        </div>
        <div class="itemMujeres">
          <h3 class="tituloTabla">EDAD QUINQUENAL</h3>

          <table class="tablaNivelEducativo">
            <thead>
              <tr>
                <th>QUINQUENAL</th>
                <th>Trabajadoras</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>15-19 años</td>
                <td>1</td>
              </tr>
              <tr>
                <td>20-24 años</td>
                <td>456</td>
              </tr>
              <tr>
                <td>25-29 años</td>
                <td>1461</td>
              </tr>
              <tr>
                <td>30-34 años</td>
                <td>2786</td>
              </tr>
              <tr>
                <td>35-39 años</td>
                <td>5459</td>
              </tr>
              <tr>
                <td>40-44 años</td>
                <td>6532</td>
              </tr>
              <tr>
                <td>45-49 años</td>
                <td>6889</td>
              </tr>
              <tr>
                <td>50-54 años</td>
                <td>5335</td>
              </tr>
              <tr>
                <td>55-59 años</td>
                <td>3405</td>
              </tr>
              <tr>
                <td>60-64 años</td>
                <td>1772</td>
              </tr>
              <tr>
                <td>65-69 años</td>
                <td>517</td>
              </tr>
              <tr>
                <td>70+ años</td>
                <td>196</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td><strong>Total</strong></td>
                <td><strong>34809</strong></td>
              </tr>
            </tfoot>
          </table>

        </div>
        <div class="itemMujeres">
          <img src={imgMujer} alt="" srcset="" />
          <div className='d-flex gap-4 justify-content-around'>
            <div>
              <h1 className='tituloConcepto'>19 mil </h1>
              <h5 className='tituloTabla mb-1'>Hombres</h5>
            </div>
            <div>
              <h1 className='tituloConcepto'>35 mil </h1>
              <h5 className='tituloTabla mb-1'>Mujeres</h5>
            </div>
          </div>
          <div className='d-flex flex-column gap-1 '>
            <h5 className='tituloTabla mt-5 justify-content-center'>45.85 años</h5>
            <h5 className='tituloTabla mb-1'>EDAD PROMEDIO</h5>
          </div>
        </div>
        <div class="itemMujeres">
          <TrabajadorasChart />
        </div>
        <div class="itemMujeres"><MapaVeracruzM /></div>
        <div class="itemMujeres">
          <h4 class="tituloTabla">OTROS ESTADOS</h4>

          <table class="tablaNivelEducativo">
            <thead>
              <tr>
                <th>EdoNac</th>
                <th>Recuento de Genero</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>Aguascalientes</td><td>3</td></tr>
              <tr><td>Baja California</td><td>23</td></tr>
              <tr><td>Campeche</td><td>27</td></tr>
              <tr><td>Chiapas</td><td>125</td></tr>
              <tr><td>Chihuahua</td><td>19</td></tr>
              <tr><td>Ciudad de México</td><td>996</td></tr>
              <tr><td>Coahuila</td><td>26</td></tr>
              <tr><td>Colima</td><td>3</td></tr>
              <tr><td>Durango</td><td>13</td></tr>
              <tr><td>Guanajuato</td><td>21</td></tr>
              <tr><td>Guerrero</td><td>31</td></tr>
              <tr><td>Hidalgo</td><td>29</td></tr>
              <tr><td>Jalisco</td><td>56</td></tr>
              <tr><td>México</td><td>166</td></tr>
              <tr><td>Michoacán</td><td>131</td></tr>
              <tr><td>Morelos</td><td>23</td></tr>
              <tr><td>Nacido en el Extranjero</td><td>19</td></tr>
              <tr><td>Nayarit</td><td>9</td></tr>
              <tr><td>Nuevo León</td><td>31</td></tr>
              <tr><td>Oaxaca</td><td>132</td></tr>
              <tr><td>Puebla</td><td>585</td></tr>
              <tr><td>Querétaro</td><td>64</td></tr>
              <tr><td>Quintana Roo</td><td>9</td></tr>
              <tr><td>San Luis Potosí</td><td>64</td></tr>
              <tr><td>Sinaloa</td><td>58</td></tr>
              <tr><td>Sonora</td><td>15</td></tr>
              <tr><td>Tabasco</td><td>108</td></tr>
              <tr><td>Tamaulipas</td><td>73</td></tr>
              <tr><td>Tlaxcala</td><td>36</td></tr>
              <tr><td>Yucatán</td><td>29</td></tr>
              <tr><td>Zacatecas</td><td>6</td></tr>
            </tbody>
            <tfoot>
              <tr>
                <td><strong>Total</strong></td>
                <td><strong>3618</strong></td>
              </tr>
            </tfoot>
          </table>

        </div>
        <div class="item">
          <div className=''>
            <h4 class="tituloTabla">EN TIEMPO DE JUBILACIÓN</h4>
            <table class="tablaNivelEducativo">
              <thead>
                <tr>
                  <th>Tipo Jubilación</th>
                  <th>Total CURP Únicos</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>CESANTÍA EN EDAD AVANZADA</td>
                  <td>8</td>
                </tr>
                <tr>
                  <td>EDAD Y TIEMPO DE SERVICIO</td>
                  <td>217</td>
                </tr>
                <tr>
                  <td>JUBILACIÓN DIRECTA</td>
                  <td>3260</td>
                </tr>
                <tr>
                  <td>N/A</td>
                  <td>31324</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td><strong>Total</strong></td>
                  <td><strong>34809</strong></td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div className=''>
            <svg className='iconoTablero mt-3 mx-2' id="fi_5784502" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg"><g><path d="m220.605 50.395c-5.859-5.859-15.352-5.859-21.211 0l-15.115 15.115c-5.867-2.807-12.352-4.51-19.279-4.51-24.814 0-45 20.186-45 45s20.186 45 45 45 45-20.186 45-45c0-6.927-1.703-13.412-4.51-19.279l15.115-15.115c5.86-5.86 5.86-15.352 0-21.211z"></path><path d="m467 271c-41.353 0-75-33.647-75-75v-15c0-4.807-.716-9.423-1.789-13.905-12.241 8.685-27.096 13.905-43.211 13.905-26.711 0-50.043-14.143-63.334-35.231-7.251 9.919-11.666 22.029-11.666 35.231 0 4.073 0 298.427 0 285 0 8.291 6.709 15 15 15s15-6.709 15-15v-135h30v135c0 8.291 6.709 15 15 15s15-6.709 15-15v-150c0-26.455 6.211-38.892 13.418-53.291 1.382-2.763 2.783-5.748 4.175-8.719 11.763 17.67 28.755 31.448 48.721 39.412-3.912 6.666-6.314 14.325-6.314 22.598 0 8.291 6.709 15 15 15s15-6.709 15-15c0-8.276 6.724-15 15-15s15 6.724 15 15v150c0 8.291 6.709 15 15 15s15-6.709 15-15v-150c0-24.814-20.186-45-45-45z"></path><path d="m392 106v-30c0-24.814-20.186-45-45-45s-45 20.186-45 45v30c0 24.814 20.186 45 45 45s45-20.186 45-45z"></path><path d="m120 196c0 41.353-33.647 75-75 75-24.814 0-45 20.186-45 45v150c0 8.291 6.709 15 15 15s15-6.709 15-15v-150c0-8.276 6.724-15 15-15s15 6.724 15 15c0 8.291 6.709 15 15 15s15-6.709 15-15c0-8.273-2.402-15.932-6.313-22.599 19.966-7.963 36.958-21.742 48.721-39.412 1.392 2.972 2.792 5.956 4.175 8.719 7.206 14.4 13.417 26.837 13.417 53.292 0 24.188 0 153.081 0 150 0 8.291 6.709 15 15 15s15-6.709 15-15v-45h30v45c0 8.291 6.709 15 15 15s15-6.709 15-15c0-5.229 0-297.828 0-285 0-13.202-4.415-25.312-11.666-35.231-13.291 21.088-36.623 35.231-63.334 35.231-16.115 0-30.97-5.22-43.211-13.905-1.073 4.482-1.789 9.098-1.789 13.905z"></path></g></svg>
          </div>
        </div>
      </div>


    </>
  )
}

export default DashboardMujeres